import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { getToken, getUser } from "../features/auth/slice/user.selector";
import storageService from "../utils/local-storage.utils";

interface IProps {
  component: React.FC;
  path: string;
  exact: boolean;
}

const AdminPrivateRoute: React.FC<IProps> = (props) => {
  const { path, exact, component } = props;
  let token = useSelector(getToken);
  const {role} = useSelector(getUser)

  // After refresh, Redux token is cleared by excludeTokenTransform.
  // Check encrypted localStorage as fallback so we don't redirect prematurely.
  if (!token) {
    token = storageService.getItem<string>('token') || '';
  }

  const condition = (token && role == "ADMIN") ? true: false;

  return condition ? (
    <Route path={path} exact={exact} component={component} />
  ) : (
    <Redirect to="/" />
  );
};
export default AdminPrivateRoute;
